const InitCareer =  {
  careerStatus() {
    return {
      // inputGradute: '2007',
      // inputName: '김영진',
      // inputBirth: '2017/09/14',
      // inputTel: '02-333-2770',
      // inputEmail: 'zeein81@gmail.com',
      // inputJobChange: 'yes',
      // inputJobStatus: 'study',
      // inputCompany: '클라우드폴더',
      // inputRole: '디자인',
      modalTitle: '',
      btnLabel: '',
      mode: '',
      inputGradute: '',
      inputName: '',
      inputBirth: '',
      inputTel: '',
      inputEmail: '',
      inputJobChange: '',
      inputJobStatus: '',
      inputCompany: '',
      inputRole: '',
      inputHighschool: '',
      isLoading: false,

      filterJobChange: '',
      filterGradute: '',
      filterString: '',

      targetUid: '',

      counselDate: '',
      counselName: '홍길동',
      counselType: '',
      counselCareers: [],
      counselContent: '상담해주세요.',
      counselRequest: '',

      init() {
        const urlParams = new URLSearchParams(window.location.search);

        // URL에 파라미터가 있으면 해당 Alpine 변수에 세팅
        if (urlParams.has('searchJobChange')) {
          this.filterJobChange = urlParams.get('searchJobChange');
        }

        if (urlParams.has('searchGradute')) {
          this.filterGradute = urlParams.get('searchGradute');
        }

        if (urlParams.has('searchString')) {
          this.filterString = urlParams.get('searchString');
        }
        this.makeToday();
      },

      makeToday() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
        const day = String(today.getDate()).padStart(2, '0');
        this.counselDate = `${year}/${month}/${day}`;
      },
      filterSearch() {
        const jobChange = this.filterJobChange;
        const gradute = this.filterGradute;
        const string = this.filterString;

        const url = new URL(window.location.href);
        const params = url.searchParams;

        // 값이 있을 경우 파라미터 추가, 없으면 제거
        params.set('paged', 1);
        if (jobChange) {
          params.set('searchJobChange', jobChange);
        } else {
          params.delete('searchJobChange');
        }

        if (gradute) {
          params.set('searchGradute', gradute);
        } else {
          params.delete('searchGradute');
        }

        if (string) {
          params.set('searchString', string);
        } else {
          params.delete('searchString');
        }

        // 새 URL로 리디렉션 (페이지 리로딩)
        window.location.href = `${url.pathname}?${params.toString()}`;
      },
      filterSearchReset() {
        this.filterJobChange = '';
        this.filterGradute = '';
        this.filterString = '';
        const url = new URL(window.location.href);
        const params = url.searchParams;
        params.delete('searchJobChange');
        params.delete('searchGradute');
        params.delete('searchString');
        params.set('paged', 1);
        window.location.href = `${url.pathname}?${params.toString()}`;
      },
      modalAdd() {
        this.mode = 'add';
        this.targetUid = '';
        this.modalTitle = '졸업생 추가';
        this.btnLabel = '학생등록';
        this.inputGradute = '';
        this.inputName = '';
        this.inputBirth = '';
        this.inputTel = '';
        this.inputEmail = '';
        this.inputJobChange = '';
        this.inputJobStatus = '';
        this.inputCompany = '';
        this.inputRole = '';
        this.inputHighschool = '';

        const modal = document.getElementById('modalCareer');
        if (modal) {
          modal.removeAttribute('aria-hidden');
          document.activeElement?.blur();
          $('#modalCareer').modal('show');
        }
      },
      async modalDelete(event) {
        if (this.isLoading) return;
        if (confirm('정말 삭제하시겠습니까?') === false) return;
        this.isLoading = true;
        this.targetUid = event.target.dataset.uid;
        try {
          const response = await fetch(frontendAjaxObject.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
              action: 'career_delete',
              nonce: frontendAjaxObject.nonce,
              targetUid: this.targetUid,
            }),
          });
          const data = await response.json();
          this.isLoading = false;
          if (data.success) {
            alert(data.message || '정상적으로 처리되었습니다.');
            location.reload();
          } else {
            alert(data.message || 'There was an error deleting the record. Please try again later.');
          }
        } catch(error) {
          console.error('Error:', error);
          alert('서버 통신 중 오류가 발생했습니다.');
        } finally {
          this.isLoading = false;
        }
      },
      async modalModify(event) {
        if (this.isLoading) return;
        this.isLoading = true;
        this.targetUid = event.target.dataset.uid;
        try {
          const response = await fetch(frontendAjaxObject.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
              action: 'career_modify',
              nonce: frontendAjaxObject.nonce,
              targetUid: this.targetUid,
            }),
          });
          const data = await response.json();
          if (data.success) {
            this.modalTitle = '졸업생 수정';
            this.mode = 'modify';
            this.btnLabel = '졸업생 수정';
            this.inputGradute = data.data.received.gradute;
            this.inputName = data.data.received.name;
            this.inputBirth = data.data.received.birth;
            this.inputTel = data.data.received.tel;
            this.inputEmail = data.data.received.email;
            this.inputJobChange = data.data.received.job_change;
            this.inputJobStatus = data.data.received.job_status;
            this.inputCompany = data.data.received.company;
            this.inputRole = data.data.received.role;
            this.inputHighschool = data.data.received.highschool;
            $('#modalCareer').modal('show');
          }
        } catch(error) {
          console.error('Error fetching career data:', error);
          alert('서버 통신 중 오류가 발생했습니다.');
        } finally {
          this.isLoading = false;
        }
      },
      async divPrint(event) {
        if (this.isLoading) return;
        this.isLoading = true;
        this.targetUid = event.target.dataset.uid;
        try {
          const response = await fetch(frontendAjaxObject.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
              action: 'career_print',
              nonce: frontendAjaxObject.nonce,
              targetUid: this.targetUid,
            }),
          });
          const data = await response.json();
          this.isLoading = false;
          if (data.success) {
            const printWindow = window.open('', '_blank', 'height=640, width=1020');
            if (printWindow) {
              printWindow.document.write(`
                <html>
                  <head>
                    <title>졸업생 정보</title>
                    <link rel="stylesheet" href="/wp-content/themes/ilshin/assets/build/css/admin.css?ver=5.8.3" referrerpolicy="no-referrer" />
                  </head>
                  <body>
                    <div class="print-div">
                      ${data.data.printHtml}
                      <div class="button-wrap"><button type="button" class="btn-print">프린트하기</button><button type="button" class="btn-close">창닫기</button></div>
                    </div>
                    </div>
                  </body>
                  <script>document.querySelector(".btn-print").addEventListener("click", function() { window.print(); });document.querySelector(".btn-close").addEventListener("click", function() { window.close(); });</script>
                </html>
              `);
              printWindow.document.close();
              // printWindow.print();
              // printWindow.close();
            } else {
              alert('새 창을 열 수 없습니다. 팝업 차단을 확인해주세요.');
            }
          }
        } catch(error) {
          console.error('Error fetching career data:', error);
          alert('서버 통신 중 오류가 발생했습니다.');
        }
      },
      formatBirth(value) {
        const numbers = value.replace(/\D/g, '').slice(0, 8);
        if (numbers.length <= 4) return numbers;
        if (numbers.length <= 6) return numbers.slice(0, 4) + '/' + numbers.slice(4);
        return numbers.slice(0, 4) + '/' + numbers.slice(4, 6) + '/' + numbers.slice(6);
      },
      async submitFormSign() {
        if (this.isLoading) return;
        this.isLoading = true;
        try {
          const response = await fetch(frontendAjaxObject.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
              action: 'career_status',
              nonce: frontendAjaxObject.nonce,
              mode: this.mode,
              targetUid: this.targetUid,
              inputGradute: this.inputGradute,
              inputName: this.inputName,
              inputBirth: this.inputBirth,
              inputTel: this.inputTel,
              inputEmail: this.inputEmail,
              inputJobChange: this.inputJobChange,
              inputJobStatus: this.inputJobStatus,
              inputCompany: this.inputCompany,
              inputRole: this.inputRole,
              inputHighschool: this.inputHighschool,
            }),
          });
          const data = await response.json();
          this.isLoading = false;
          if (data.success) {
            $('#modalCareer').modal('hide');
            this.inputGradute = '';
            this.mode = '';
            this.targetUid = '';
            this.inputName = '';
            this.inputBirth = '';
            this.inputTel = '';
            this.inputEmail = '';
            this.inputJobChange = '';
            this.inputJobStatus = '';
            this.inputCompany = '';
            this.inputRole = '';
            this.inputHighschool = '';
            // alert(data.message || '정상적으로 처리되었습니다.');
            location.reload();
          } else {
            alert(data.message || 'There was an error submitting your form. Please try again later.');
          }
        } catch(error) {
          console.error('Error:', error);
          alert('서버 통신 중 오류가 발생했습니다.');
        } finally {
          this.isLoading = false;
        }
      },

      async modalCounsel(event) {
        if (this.isLoading) return;
        this.isLoading = true;
        this.targetUid = event.target.dataset.uid;
        try {
          const response = await fetch(frontendAjaxObject.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
              action: 'get_career_counsel',
              nonce: frontendAjaxObject.nonce,
              targetUid: this.targetUid,
            }),
          });
          const data = await response.json();
          if (data.success) {
            this.counselDate = data.data.received.counselDate || '';
            this.counselName = data.data.received.counselName || '';
            this.counselType = data.data.received.counselType || '';
            this.counselCareers = data.data.received.counselCareers || [];
            this.counselContent = data.data.received.counselContent || '';
            this.counselRequest = data.data.received.counselRequest || '';
            $('#modalCounsel').modal('show');
          }
        } catch(error) {
          console.error('Error fetching counsel data:', error);
          alert('서버 통신 중 오류가 발생했습니다.');
        } finally {
          this.isLoading = false;
        }
      },

      async submitFormCounsel() {
        if (this.isLoading) return;
        this.isLoading = true;
        try {
          const response = await fetch(frontendAjaxObject.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
              action: 'career_counsel',
              nonce: frontendAjaxObject.nonce,
              targetUid: this.targetUid,
              counselDate: this.counselDate,
              counselName: this.counselName,
              counselType: this.counselType,
              counselCareers: JSON.stringify(this.counselCareers),
              counselContent: this.counselContent,
              counselRequest: this.counselRequest,
            }),
          });
          const data = await response.json();
          this.isLoading = false;
          if (data.success) {
            $('#modalCareer').modal('hide');
            alert(data.message || '정상적으로 처리되었습니다.');
            location.reload();
          } else {
            alert(data.message || 'There was an error submitting your form. Please try again later.');
          }
        } catch(error) {
          console.error('Error:', error);
          alert('서버 통신 중 오류가 발생했습니다.');
        } finally {
          this.isLoading = false;
        }
      },
      counselCareerAdd() {
        this.counselCareers.push({
          period1: '',
          period2: '',
          company: '',
          role: '',
          reason: '',
        });
      },
      counselCareerRemove(index) {
        this.counselCareers.splice(index, 1);
      }
    }
  }
}
export { InitCareer };

